// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Z1KMm","left":"styles_left__3Is3m"};